<template>
  <v-layout>
    <v-panel>
      <div slot="body">
        <div class="d-flex flex-column align-items-center justify-content-center welcome-content">
          <div class="d-flex justify-content-center align-items-center welcome-header">
            <span class="mr-3">👋</span>
            <h1 class="text-uppercase">{{ $t('modal.welcome') }} {{ account.first_name }} !</h1>
          </div>
          <div class="mb-30">
            <iframe src="https://player.vimeo.com/video/826078811"
                    width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen
                    title="welcome-outil.mov">
            </iframe>
          </div>
          <div class="start-now-btn">
            <button class="btn btn-primary btn-center waves-effect waves-classic btn-save text-uppercase">
              <a href="https://superhote.com/commencer" target=_blank class="start-link text-decoration-none"> {{ $t('button.get_started') }}</a>
            </button>
          </div>
        </div>
      </div>
    </v-panel>
  </v-layout>
</template>

<script>
export default {
  name: 'Onboarding',
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Onboarding.vue?3271db71